import {configureStore, combineReducers} from '@reduxjs/toolkit';
import thunk from 'redux-thunk';
import projectReducer from './project-slice';
import foldersReducer from './folders-slice';
import assetsReducer from './assets-slice';
import projectionsReducer from './projections-slice';
import settingsReducer from './settings-slice';
import cameraReducer from './camera-slice';
import bookmarksReducer from './bookmarks-slice';
import {
  isMobile,
  parseURLParams,
  getModifiedSceneState,
  getModifiedAerialState,
  toBoolean
} from '../viewer/js/utilities';
import { isStaticSite } from '../electron-modules';

const appReducer = combineReducers({
  project: projectReducer,
  camera: cameraReducer,
  folders: foldersReducer,
  projections: projectionsReducer,
  settings: settingsReducer,
  assets: assetsReducer,
  bookmarks: bookmarksReducer
});

export const updateStateFromParams = (config, staticURL) => {
  if (!staticURL) {
    return config;
  }

  const parameters = parseURLParams(staticURL);
  if (!parameters) {
    return config;
  }

  const modifiedSceneState = getModifiedSceneState(
    config.camera.sceneState, parameters);

  const modifiedAerialState = getModifiedAerialState(
    config.camera.aerialState, parameters);

  if ("expanded" in parameters) {
    const switched = toBoolean(parameters.expanded);
    config.settings.switched = switched;
  }

  config.camera.sceneState = modifiedSceneState;
  config.camera.aerialState = modifiedAerialState;

  return config;
};

const rootReducer = (state, action) => {
  const newProject = action.type === 'NEW';
  const loadConfig = action.type === 'LOAD';
  const configInit = state === undefined;

  if (loadConfig) {
    state = action.payload.projectJSON;
  }

  if (newProject) {
    state = undefined;
  }

  let modified = appReducer(state, action);

  if (loadConfig && isStaticSite) {
    const {staticURL} = action.payload;
    modified = updateStateFromParams(modified, staticURL);
  }

  if (configInit || newProject) {
    modified = appReducer(modified, {
      type: "settings/applySavedDefaults",
      payload: null
    });
  }

  if (newProject || loadConfig) {
    modified = appReducer(modified, {
      type: "project/refreshModified",
      payload: null
    });
  }

  // Asset drawer will be forced to closed
  // for mobile devices on initial load
  if (loadConfig && isMobile) {
    modified = appReducer(modified, {
      type: "settings/changeDrawerOpen",
      payload: false
    });
  }

  if (loadConfig) {
    appReducer(modified, {
      type: "settings/changeDefaultSettings",
      payload: null
    });
  }

  return modified;
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: [thunk],
});